import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
    imports: [
        AngularSvgIconModule,
        ImageCdnSrcDirective,
        MatDialogModule,
        NgClass,
    ],
    selector: 'rdx-confirmation-dialog',
    standalone: true,
    styleUrls: ['./confirmation-dialog.component.scss'],
    templateUrl: './confirmation-dialog.component.html',
})
/** @deprecated - Use ConfirmDialogComponent */
export class ConfirmationDialogComponent {
    @Input() dialogId: string;
    @Input() hideCancelButton = false;
    @Input() hideCenterButton = true;
    @Input() titleText: string;
    @Input() contentText: string;
    @Input() cancelText = $localize`Cancel`;
    @Input() confirmText = $localize`OK`;
    @Input() cancelButtonId = 'cancel';
    @Input() confirmButtonId = 'confirm';
    @Input() cancelAriaLabel = 'cancel';
    @Input() confirmAriaLabel = 'confirm';
    @Input() hasNoWrap = false;
    @Input() hasCloseButton = false;
    @Input() centerButtonText = $localize`Discard`;
    @Input() centerButtonId = 'discard';
    @Input() hideAppStoreButtons = true;

    playStoreUrl: string;
    appStoreUrl: string;

    constructor(
        configService: ConfigService,
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>
    ) {
        this.playStoreUrl = configService.appStoreUrl.google;
        this.appStoreUrl = configService.appStoreUrl.apple;
    }
}
